import "core-js/features/url-search-params";
import { VALIDATIONS, PATHS } from "./config";
import { authorize, getToken } from "./starfleet-auth";
import { saveSessionInfo, redirect } from "./utils";

const urlParams = new URLSearchParams(location.href.split(/(\?|#)/)[2]);
const redirect_uri = urlParams.get("redirect_uri");

let path = location.pathname;
//set path to /auth/gtc if it begins with /auth/gtc

if (path?.startsWith("/auth/gtc")) {
  path = "/auth/gtc";
}
if (path?.startsWith("/auth/aid")) {
  path = "/auth/aid";
}
if (path?.startsWith("/auth/events")) {
  path = "/auth/events";
}

if (PATHS[path]) {
  const scriptElement = document.createElement("script");
  scriptElement.src = PATHS[path];
  document.head.appendChild(scriptElement);
} else if (redirect_uri && redirect_uri.match(VALIDATIONS.urlRegex)) {
  // if redirect_uri is present, start auth flow
  authorize(
    redirect_uri,
    urlParams.get("client_id"),
    urlParams.get("ui_locales"),
    urlParams.get("idp_id"),
    urlParams.get("login_hint"),
    urlParams.get("prompt"),
    urlParams.get("state")
  );
} else if (urlParams.has("access_token")) {
  // if access_token is present, save session and redirect
  handleAccessTokenFlow();
} else if (urlParams.has("code")) {
  // handling the PKCE authorization
  handlePKCEFlow(urlParams.get("code"), urlParams.get("ui_locales"));
} else if (urlParams.has("error")) {
  const passedState = JSON.parse(atob(urlParams.get("state")));
  if (passedState?.prompt === "none") {
    //handling silent login
    console.log(urlParams.toString());
    window.parent.postMessage("failure");
  } else {
    // if error is present, take the user where he initiated the login
    sessionStorage.setItem("AuthError", urlParams.get("error"));
    redirect(passedState.referrer);
  }
}

async function handlePKCEFlow(code, ui_locales) {
  try {
    const TokenData = await getToken(code, ui_locales);
    for (const key in TokenData.data) {
      urlParams.append(key, TokenData.data[key]);
    }
  } catch (error) {
    console.log("error redeeming the token");
    redirect(JSON.parse(atob(urlParams.get("state"))).referrer);
  }

  handleAccessTokenFlow();
}

function handleAccessTokenFlow() {
  const passedState = JSON.parse(atob(urlParams.get("state")));
  saveSessionInfo(urlParams, passedState);
  if (passedState?.prompt === "none") {
    //handling silent login
    window.parent.postMessage("success");
    redirect(passedState.referrer);
  } else if (!passedState.state) {
    redirect(passedState.referrer);
  } else {
    const urlConnector = passedState.referrer.includes("?")
      ? "&state="
      : "?state=";
    redirect(
      `${passedState.referrer}${urlConnector}${encodeURIComponent(
        passedState.state
      )}`
    );
  }
}
